/* eslint-disable no-prototype-builtins */
import React from 'react'
import { Helmet } from 'react-helmet-async'

// Change Header of a page for title, seo, and analytics purposes
export const seoPageTags = (title) => {
  // console.log('helmet title ->', title)
  return (
    <>
      <Helmet>

        { /* Standard metadata tags */ }
        {title === 'Home' ?
          <title>Swipelytics — Optimize Your Dating Profile — {title}</title>
          :
          <title>Swipelytics — {title}</title>
        }
        <meta name='description' content={'Detailed Feedback. Optimized Profiles. Better Matches.'} />

        {/* Referrer Policy */}
        <meta name="referrer" content="origin" />

        { /* Facebook tags */ }
        <meta property="og:type" content={'website'} />
        <meta property="og:title" content={`Swipelytics — Optimize Your Dating Profile — ${title}`} />
        <meta property="og:description" content={'A software service for optimizing dating profiles by gathering and implementing expert, friend, and AI feedback on images, bios, and the overall story that a profile tells about a person.'} />

        {/* Yandex Verification */}
        {/* <meta name="yandex-verification" content="08a79e53272c53b3" /> */}

        { /* Twitter tags */ }
        <meta name="twitter:creator" content={'Swipelytics'} />
        <meta name="twitter:card" content={'website'} />
        <meta name="twitter:title" content={`Swipelytics — Optimize Your Dating Profile — ${title}`} />
        <meta name="twitter:description" content={'A software service for optimizing dating profiles by gathering and implementing expert, friend, and AI feedback on images, bios, and the overall story that a profile tells about a person.'} />



        {/* <!-- Meta Pixel Code --> */}
        {/* <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${process.env.REACT_APP_META_PIXEL_ID}');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`
            <img height="1" width="1" style="display:none"
              src="https://www.facebook.com/tr?id=${process.env.REACT_APP_META_PIXEL_ID}&ev=PageView&noscript=1"
            />
          `}
        </noscript> */}
        {/* <!-- End Meta Pixel Code --> */}

        {/* Google Analytics — Must be at bottom of Helmet */}
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}`}></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}');
          `}
        </script>
      </Helmet>
    </>
  )
}

// Send a custom analytics event to Google Analytics
export const customAnalyticsEvent = (eventName, value, category, label, screenName) => {
  if (typeof window !== 'undefined' && window.hasOwnProperty('gtag')) {
    window.gtag('event', eventName, {
      value: value,
      event_category: category,
      event_label: label,
      screen_name: screenName,
    })
    
  }
}

// Custom Pixel Event
export const customPixelEvent = (eventName, customizationsObj = {}) => {
  if (typeof window !== 'undefined' && window.hasOwnProperty('fbq')) {
    window.fbq(
      'track', 
      eventName, 
      {
        ...customizationsObj,
      }
    )
  }
}

export const customGTAGHead = (title) => {
  return (
    <>
      {/* Title */}
      {title === 'Home' ?
        <title>Swipelytics — Optimize Your Dating Profile — {title}</title>
        :
        <title>Swipelytics — {title}</title>
      }
      <meta name='description' content={'Detailed Feedback. Optimized Profiles. Better Matches.'} />

      {/* Referrer Policy */}
      <meta name="referrer" content="origin" />

      {/* Google Analytics — Must be at bottom of Helmet */}
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}`}></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}');
        `}
      </script>

    </>
  )
}

export const runGTAGScript = async (title = 'Home') => {
  return (
    <>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}`}></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}', {
            page_title: ${title === 'Home' ? `Swipelytics — Optimize Your Dating Profile — ${title}` : `Swipelytics — ${title}`},
          });
        `}
      </script>
    </>
  )
}

export const registerPageViewsInsideMetaBrowser = async (title) => {

  // Google Analytics
  if (typeof window !== 'undefined' && (!(window.hasOwnProperty('gtag') || (window.hasOwnProperty('gtag') && typeof window.gtag === 'undefined')))) {
    await runGTAGScript(title)

    window.gtag?.('event', 'page_view', {
      // page_location: window.location.href,
      // page_path: location.pathname,
      page_title: title === 'Home' ? `Swipelytics — Optimize Your Dating Profile — ${title}` : `Swipelytics — ${title}`,
    })
  } else if (typeof window !== 'undefined' && window.hasOwnProperty('gtag') && typeof window.gtag !== 'undefined') {
    // gtag('config',`${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}`, {
    //   page_title: title === 'Home' ? `Swipelytics — Optimize Your Dating Profile — ${title}` : title,
    // })
    window.gtag?.('event', 'page_view', {
      // page_location: window.location.href,
      // page_path: location.pathname,
      page_title: title === 'Home' ? `Swipelytics — Optimize Your Dating Profile — ${title}` : `Swipelytics — ${title}`,
    })
  }

  // Facebook Pixel
  if (typeof window !== 'undefined' && window.hasOwnProperty('fbq')) {
    window.fbq?.('track', 'PageView', {
      title: title,
    })
  }
}